/*
  import { vendorLicense } from '@/services/Vendors/VendorLicenses/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'

import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await vendorLicense.dispatch ('getVendorLicenseList', {
      vendorID
    });
  */
  async getVendorLicenseList({}, { vendorGlobalID }) {
    console.log('in getVendorLicenseList...')
    try {
      const result = await kms.get('/Vendors/VendorGlobalLicense/List', {
        params: {
          vendorGlobalID
        }
      })

      if (isDebug == true) console.debug('getVendorLicenseList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The vendor licenses list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const vendorLicense = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
